import BgColorChange from './header/bgcolorChange';
import MegaNaviPC from './header/meganaviPC';
import StorePC from './header/storePC';
import MegaNaviTablet from './header/meganaviTablet';
import MeganaviStoreSP from './header/meganaviStoreSP';

const meganaviPC = new MegaNaviPC($("#l-header__navi"),$("#l-header__navi-list>ul>li"),$('#c-overlay'));
const meganaviTablet = new MegaNaviTablet($("#l-header__navi"),$("#l-header__navi-list>ul>li"),$('#c-overlay'),$(".l-header__meganavi-acc"))
const storePC = new StorePC($('#c-overlay'),$("#l-header__fixed"),$("#l-header__btn-store"),$("#l-header__btn-online"),$("#l-header__top-text"));
const meganaviStoreSP = new MeganaviStoreSP($("#l-header__navi"),$('#c-overlay'),$("#l-header__fixed"),$("#l-header__btn-store"),$("#l-header__btn-online"),$("#l-header__top-text"));

const bgColorChange = new BgColorChange();

var header = {

    $header : $("#l-header"),
    $fixed : $("#l-header__fixed"),
    $trigger : $("#l-header__trigger"),
    $navi : $("#l-header__navi"),
    $naviList : $("#l-header__navi-list>ul>li"),
    // $dropdownNavi : $(".l-header__meganavi"),
    $storeBtn : $("#l-header__btn-store"),
    $storeList : $("#l-header__btn-store__list"),
    $onlineBtn : $("#l-header__btn-online"),
    $onlineList : $("#l-header__btn-online__list"),
    $fontBtn : $("#l-header__top-text"),
    $fontList : $("#l-header__top-text__size"),
    $overlay : $('#c-overlay'),
    $Acc : $(".l-header__meganavi-acc"),
    $AccIcon : $(".l-header__meganavi-acc_icon"),
    h      : 0,
    Position : 0,
    // hoverTime : '',
    open:false,
    MOUSEWHEEL : 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll',

    init : function () {

        // ---------------- pc ---------------- //

        //meganavi

        meganaviPC.init();
        storePC.init();

        // ---------------- tablet ---------------- //

        meganaviTablet.init();

        // ---------------- sp ---------------- //

        meganaviStoreSP.init();

        $('.l-header__meganavi-list__text a').click(function() {
            var _url = $(this).attr('href');
            if ( _url.indexOf('#') != -1) {
                var $target  = _url.indexOf('#');
                $target = _url.substring($target);
                meganaviStoreSP.meganavi(meganaviStoreSP.$navi,'hide');
                setTimeout(function(){
                    var _posi = $($target).offset().top - $('#l-header__fixed').height();
                    $(window).scrollTop(_posi);
                },3e2);

            }
        })

    },

    resize : function () {
        // header.$navi.removeAttr('style');
        // header.$dropdownNavi.removeAttr('style');
        meganaviPC.resize();
        $('.l-header__meganavi-list').removeAttr('style');
        kvH = $('#l-kv').height();
        hH = $('#l-header').height();
        let _naviW = $('#l-header__btn').width();
        header.$storeList.width(_naviW);
        header.$onlineList.width(_naviW);
    },

}

let kvH;
let hH;
let scr;
let scrSaveFlg = false;
let openFlg = false;

header.init();
header.resize();

let timerR = false;
let winW = window.innerWidth;
let winWR;

$(window).on('resize',function () {
    if (timerR !== false) {
        clearTimeout(timerR);
    }
    timerR = setTimeout(function() {
        winWR = window.innerWidth;
        if ( winW != winWR ) { // 横幅が変わった時実行する処理
            header.$storeList.removeAttr('style');
            header.$onlineList.removeAttr('style');
            if(winWR > 750){
                header.resize();
            }
            else{

            }
            winW = $(window).width();
        }
    }, 200);
});
$(window).on('load scroll',function () {
    if(openFlg) return false;
    // header.color(scr);
    if($("#l-header__btn-online__list").hasClass('open') || $("#l-header__btn-store__list").hasClass('open') || $("#l-header__navi").hasClass('open')) return;
    bgColorChange.update($(window).scrollTop(),kvH,hH);
});



$(function(){
    $("#l-header__btn-store__list").mCustomScrollbar();
    $("#l-header__btn-online__list").mCustomScrollbar();
});

